// extracted by mini-css-extract-plugin
export default {"aboutSectionOne":"SectionOne_aboutSectionOne__UqI-W"};